import parse from 'html-react-parser';
import Constants, { LANGUAGE_OPTIONS } from './Constants';
import { useEffect } from 'react';
import { AssessmentClipIcon } from './Labels/Labels';
let Utils = {
  convertNewLineToHTMLBreak: function (text) {
    return parse(text.replace(/(?:\r\n|\r|\n)/g, '<br />'));
  },

  getAlphabetFromNumbers(indexes, separator) {
    if (typeof indexes === 'string' || typeof indexes === 'number') {
      indexes = parseInt(indexes) - 1;
      return this.getAlphabetFromNumber(indexes);
    } else if (Array.isArray(indexes)) {
      var result = [];
      indexes.forEach((_index, key) => {
        _index = parseInt(_index) - 1;
        result.push(this.getAlphabetFromNumber(_index));
      });
      if (separator) {
        return result.join(separator);
      } else {
        return result;
      }
    } else {
      return indexes;
    }
  },

  getAlphabetFromNumber(index) {
    if (index >= 0) {
      return String.fromCharCode(65 + index);
    } else {
      return '';
    }
  },

  getOptionFromIndex(options, optionIndexes) {
    let ans = [];
    if (typeof optionIndexes === 'object' && optionIndexes.length > 0) {
      optionIndexes.map(function (index) {
        ans.push(options[index - 1]);
      });
    } else if (typeof optionIndexes === 'number' || typeof n === 'string') {
      ans.push(options[optionIndexes - 1]);
    }
    return ans;
  },

  dataConstruction(userAnswerReview) {
    let response = '';
    let xAxisResponse = '';
    let yAxisResponse = '';

    if (userAnswerReview && userAnswerReview.value) {
      let axisValues = userAnswerReview.value;
      if (axisValues && axisValues.xAxis) {
        xAxisResponse = 'X Axis - ' + axisValues.xAxis.join(',') + '<br/>';
      }

      if (axisValues && axisValues.yAxis) {
        yAxisResponse = 'Y Axis - ' + axisValues.yAxis.join(',');
      }

      if (xAxisResponse.length > 0 || yAxisResponse.length > 0) {
        response = xAxisResponse + ' ' + yAxisResponse;
      } else {
        response = 'Wrong attributes on axis.';
      }
    } else {
      response = 'Wrong attributes on axis.';
    }

    return response;
  },

  getRandomString() {
    return Math.random().toString(36).substring(2, 7);
  },

  convertObjectToFormData(obj) {
    var form_data = new FormData();
    for (var key in obj) {
      form_data.append(key, obj[key]);
    }

    return form_data;
  },

  getPreferredSubjectCategory(subjectCategories) {
    const counts = subjectCategories.reduce(function (categoryCounts, elem) {
      const existingCategoryCount = categoryCounts.find(
        cc => cc.category === elem.category,
      );
      if (existingCategoryCount) {
        existingCategoryCount.count += 1;
      } else {
        categoryCounts.push({ category: elem.category, count: 1 });
      }
      return categoryCounts;
    }, []);

    //get category which has more subjects will be shown as default filter type in content library
    const maxCc = counts.reduce(
      (maxCc, cc) => (maxCc.count < cc.count ? cc : maxCc),
      { category: Constants.CONTENT_LIBRARY.OTHER_SUBJECT_CATEGORY, count: 0 },
    );
    return maxCc.category === Constants.CONTENT_LIBRARY.OTHER_SUBJECT_CATEGORY
      ? Constants.CONTENT_LIBRARY.DEFAULT_SUBJECT_CATEGORY
      : maxCc.category.toLowerCase();
  },

  validateZeroOrPositiveNumber(myNumber) {
    const numberRegEx = /^[0-9]/;
    return numberRegEx.test(String(myNumber).toLowerCase());
  },

  // Whether a teacher can use the Content Builder (create custom activities).
  // `content` is optional: when provided, the teacher must also be able to
  // access that content's subscription tier; when omitted, it's a pure
  // teacher-capability check. Staff / superuser always have access.
  hasAccessToContentBuilder(user, content) {
    if (!user || user.type !== 'teacher') return false;
    if (user.is_staff || user.is_superuser) return true;
    if (!content) return true;
    return Utils.canAccessContent(content, user);
  },

  debounce(callback, delay = 500) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => callback(...args), delay);
    };
  },

  normalizeAppConfData(data) {
    let configData = {};
    if (data.appname === 'partner') {
      configData['isPartner'] = true;
    } else if (data.appname === 'doctrina') {
      configData['isDoctrina'] = true;
      // mySci instance has Assessments support
      if (data.config.app_name === 'mysci') {
        configData['showAssessments'] = true;
      } else {
        configData['showAssessments'] = false;
      }
    }
    configData['google'] = data.google ? data.google : '';
    configData['onedrive'] = data.onedrive ? data.onedrive : '';
    // Partner social-auth toggles; undefined elsewhere
    configData['socialAuthGoogleEnabled'] = data.social_auth_google_enabled;
    configData['socialAuthMicrosoftEnabled'] =
      data.social_auth_microsoft_enabled;
    configData['config'] = data.config ? data.config : '';
    configData['header_config'] = data.header_config
      ? data.header_config
      : null;
    return configData;
  },

  getActiveTabForClassroom(object_type) {
    if (object_type === 'taskassessment') return 'Assessments';
    if (object_type === 'survey') return 'Surveys';
    return 'Assignments';
  },

  // To replace enter key char to html break tag
  convertEnterKeyCharToBr: function (text) {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
  },

  // To format query params for api
  formatQueryParam: function (params) {
    let queryParams = Object.entries(params)
      .filter(([key, value]) => !!value)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    return queryParams;
  },

  useTitle: function (title) {
    useEffect(() => {
      const prevTitle = document.title;
      document.title = title;
      return () => {
        document.title = prevTitle;
      };
    });
  },

  getQuestionTypeText: function (q) {
    switch (q.type) {
      case 'text':
        return 'Text Entry';
      case 'textarea':
        return 'Constructed Response';
      case 'radio':
        return 'Multiple Choice';
      case 'checkbox':
        return 'Multiselect';
      case 'graph':
        return 'Graphing';
      case 'cloze-dropdown':
        return 'Dropdown';
      case 'cloze':
        return 'Drag & Drop';
      case 'cloze-drag-image':
        return 'Image Drag & Drop';
      default:
        return '';
    }
  },

  getQuestionAbreviationText: function (type) {
    switch (type) {
      case 'text':
        return 'Text Entry';
      case 'textarea':
        return 'CR';
      case 'radio':
        return 'MC';
      case 'checkbox':
        return 'MS';
      case 'graph':
        return 'Graphing';
      case 'cloze-drag-image':
        return 'Image D&D';
      default:
        return '';
    }
  },
  getContentProgress: function (status) {
    return status
      ? status === 'Completed'
        ? status
        : `${status} Steps`
      : 'Not Started';
  },

  useOnClickOutside(ref, handler) {
    useEffect(
      () => {
        const listener = event => {
          // Do nothing if clicking ref's element or descendent elements
          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }
          handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
          document.removeEventListener('mousedown', listener);
          document.removeEventListener('touchstart', listener);
        };
      },
      //
      [ref, handler],
    );
  },
  useOnScrollOutside(ref, handler) {
    useEffect(
      () => {
        const onWheel = event => {
          // Do nothing if scrolling inside ref's element or descendent elements
          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }
          handler(event);
        };
        document.body.addEventListener('wheel', onWheel);
        return () => document.body.removeEventListener('wheel', onWheel);
      },
      //
      [ref, handler],
    );
  },
  getclassName: function (content_type, _className = false) {
    let className = 'ti p3 text-gray lh-condensed-ultra ml-1 mr-2 ';
    if (_className) {
      className = _className;
    }
    if (content_type === 'lesson') {
      className += 'ti-steps';
    } else if (content_type === 'datastory') {
      className += 'ti-datastories';
    } else if (content_type === 'dataset') {
      className += 'ti-dataset';
    } else if (content_type === 'dataset activity') {
      className += 'ti-activities';
    } else if (content_type === 'user dataset') {
      className += 'ti-dataset';
    } else if (content_type === 'external link') {
      className += 'ti-link';
    } else if (content_type === 'user dataset plot') {
      className += 'ti-chart';
    } else if (content_type === 'task') {
      className += 'ti-tasks';
    } else if (content_type === 'practice') {
      className += 'ti-content-practice';
    } else if (content_type === 'taskassessment') {
      className += 'ti-assessments';
    } else if (content_type === 'simulation') {
      className += 'ti-simulation';
    } else {
      className += 'ti-question-mark';
    }
    return className;
  },
  // `contentModel` disambiguates the one key that covers two content types:
  // 'simulation' is both a sim LESSON (Lesson with lesson_type 'simulation')
  // and a catalog Sim (the Simulation object). Pass the API's `content_model`
  // ('lesson' vs 'simulation') to tell them apart; omit it and the sim-lesson
  // reading is assumed, which is what every existing caller expects.
  getContentTypeName: function (contentType, isTuvaJr, contentModel) {
    let typeName = '';
    if (isTuvaJr) {
      typeName = 'Jr. ';
    }
    if (contentType === 'lesson' || contentType === 'datastory') {
      typeName += 'Data Story';
    } else if (contentType === 'dataset') {
      typeName += 'Dataset';
    } else if (contentType === 'course') {
      typeName += 'Course';
    } else if (contentType === 'user dataset') {
      typeName += 'User Dataset';
    } else if (contentType === 'user dataset plot') {
      typeName += 'Plot';
    } else if (contentType === 'external link') {
      typeName += 'Resource';
    } else if (
      contentType === 'activity' ||
      contentType === 'datasetactivity' ||
      contentType === 'dataset activity'
    ) {
      typeName += 'Activity';
    } else if (contentType === 'task') {
      typeName += 'Task';
    } else if (contentType === 'practice') {
      typeName += 'Practice';
    } else if (contentType === 'taskassessment') {
      typeName += 'Assessment';
    } else if (contentType === 'simulation') {
      typeName += contentModel === 'simulation' ? 'Simulation' : 'Sim Lesson';
    } else if (contentType === 'collection') {
      typeName += 'Collection';
    }
    return typeName;
  },
  getContentWrapper: function (type, is_tuva_jr, minWidth = '123px', contentModel) {
    return (
      <div className="d-flex flex-items-center" style={{ minWidth }}>
        <span
          className={`${Utils.getclassName(type, ' ti d-inline-flex mr-2 ')}`}
        ></span>
        <span>{Utils.getContentTypeName(type, is_tuva_jr, contentModel)}</span>
      </div>
    );
  },
  checkELDLabelSupport: function (tagsList) {
    return tagsList?.find(tag => tag.slug === 'eld-support');
  },

  getSubstringUpTo(str, delimiter) {
    let index = str.indexOf(delimiter); // Find the index of the delimiter
    if (index === -1) {
      return str; // Return the whole string if the delimiter isn't found
    }
    return str.substring(0, index + delimiter.length); // Include the delimiter in the result
  },

  toggleFooter(visibility) {
    const footer = document.getElementById('footer');
    if (footer) {
      footer.style.display = visibility;
    }
  },

  // ===================================================================
  // Subscription tiers — access logic
  // ===================================================================

  // The five access tiers. Mirrors the backend SubscriptionType slugs.
  SUBSCRIPTION_TIERS: [
    'premium',
    'jr',
    'assessment',
    'ose_companion',
    'tuva_sims',
  ],

  // Single source of truth for tier metadata. Add a new tier here and the
  // shared renderers / SchoolList / TeacherList / ContentType / UnitBlock
  // pick it up automatically.
  // - `className` is the SCSS tier class (no `label--` prefix variants; the
  //   chrome lives in _subscription-labels.scss under the compound selector).
  // - `text` is the user-facing label.
  // - `tooltip` is the locked-state tooltip shown over the badge.
  TIER_CONFIG: {
    premium: {
      className: 'label--tuva-premium',
      text: 'Premium',
      shortText: 'P',
      tooltip: 'Accessible for Tuva Premium Subscribers Only',
    },
    jr: {
      className: 'label--tuva-jr',
      text: 'Tuva Jr.',
      shortText: 'Jr.',
      tooltip: 'Accessible for Tuva Jr. Subscribers Only',
    },
    assessment: {
      className: 'label--tuva-assessment',
      text: 'Assessment',
      shortText: 'A',
      tooltip: 'Accessible for Assessment Subscribers Only',
      UnlockedIcon: AssessmentClipIcon,
    },
    ose_companion: {
      className: 'label--tuva-ose-companion',
      text: 'OpenSciEd Companion',
      shortText: 'OC',
      tooltip: 'Accessible for OpenSciEd Companion Subscribers Only',
    },
    tuva_sims: {
      className: 'label--tuva-sims',
      text: 'Tuva Sims',
      shortText: 'TS',
      tooltip: 'Accessible for Tuva Sims Subscribers Only',
    },
  },

  // Tier slugs a piece of content requires. Prefers the new
  // `subscription_types` array from the API; falls back to the legacy
  // is_premium / is_tuva_jr / lesson_type booleans for older responses.
  getContentSubscriptionTypes(content) {
    if (Array.isArray(content?.subscription_types)) {
      return content.subscription_types;
    }
    if (!content?.is_premium) return [];
    if (content.is_tuva_jr) return ['jr'];
    if (content.lesson_type === 'taskassessment') return ['assessment'];
    return ['premium'];
  },

  // Tier slugs the user holds. whoami always ships subscription_types
  // (see accounts/resources.py); the legacy is_premium / is_jr /
  // is_assessment booleans are ignored on purpose -- they don't cover
  // ose_companion / tuva_sims.
  getUserSubscriptionTypes(user) {
    return Array.isArray(user?.subscription_types)
      ? user.subscription_types
      : [];
  },

  // True if the user holds ANY paid tier. Use this for "is the user a
  // paid subscriber" gates -- it transparently includes ose_companion
  // and tuva_sims, unlike the old (is_premium || is_jr || is_assessment).
  hasAnySubscription(user) {
    return Utils.getUserSubscriptionTypes(user).length > 0;
  },

  // True if the user holds a specific tier. Use this for tier-specific
  // upsells / gates (e.g. "show 'Buy Premium' if user lacks premium").
  // Replaces direct user.is_premium / user.is_jr / etc. reads so we can
  // eventually drop those legacy booleans from the user object.
  userHasSubscription(user, tier) {
    return Utils.getUserSubscriptionTypes(user).includes(tier);
  },

  // OR semantics: the user can access if they hold ANY required tier.
  // Content with no required tiers is free.
  canAccessContent(content, user) {
    const required = Utils.getContentSubscriptionTypes(content);
    if (required.length === 0) return true;
    const held = Utils.getUserSubscriptionTypes(user);
    return required.some(tier => held.includes(tier));
  },

  // True when the content should render LOCKED for this user.
  // Name kept for back-compat with existing callers.
  getSubscriptionStatus(content, user) {
    const required = Utils.getContentSubscriptionTypes(content);
    if (required.length === 0) return false;
    return !Utils.canAccessContent(content, user);
  },

  // ===================================================================
  // Subscription tier labels — single renderer driven by TIER_CONFIG
  // ===================================================================
  // `isLocked` => show the lock icon. The tier tooltip is always enabled so it
  // shows in both locked and unlocked states, matching the content-library card.
  renderTierLabel(tier, isLocked, key) {
    const cfg = Utils.TIER_CONFIG[tier];
    if (!cfg) return null;
    const UnlockedIcon = cfg.UnlockedIcon;
    return (
      <span
        key={key}
        className={`p3 content-label ${cfg.className} mr-2`}
        data-tooltip-content={cfg.tooltip}
        data-tooltip-id="tuva-tooltip-id"
        data-tooltip-place="left"
      >
        {isLocked && <i className="ti ti-lock mr-1"></i>}
        {!isLocked && UnlockedIcon && <UnlockedIcon />}
        <span className="v-align-middle">{cfg.text}</span>
      </span>
    );
  },

  // Per-tier convenience wrappers — kept so existing callers keep working.
  renderPremiumLabel(isLocked, key) {
    return Utils.renderTierLabel('premium', isLocked, key);
  },
  renderJrLabel(isLocked, key) {
    return Utils.renderTierLabel('jr', isLocked, key);
  },
  renderAssessmentLabel(isLocked, key) {
    return Utils.renderTierLabel('assessment', isLocked, key);
  },
  renderOseCompanionLabel(isLocked, key) {
    return Utils.renderTierLabel('ose_companion', isLocked, key);
  },
  renderTuvaSimsLabel(isLocked, key) {
    return Utils.renderTierLabel('tuva_sims', isLocked, key);
  },

  // Map a tier slug to its label renderer.
  getSubscriptionLabelRenderer(tier) {
    return (isLocked, key) => Utils.renderTierLabel(tier, isLocked, key);
  },

  // Render the subscription label(s) for a piece of content.
  // Returns null for free content; an array of label elements otherwise
  // (one per required tier -- usually just one).
  getSubscriptionLabel(content, user) {
    const tiers = Utils.getContentSubscriptionTypes(content);
    if (tiers.length === 0) return null;
    const isLocked = Utils.getSubscriptionStatus(content, user);
    const labels = tiers
      .map(tier => {
        const renderer = Utils.getSubscriptionLabelRenderer(tier);
        return renderer ? renderer(isLocked, tier) : null;
      })
      .filter(Boolean);
    return labels.length ? labels : null;
  },

  // Back-compat alias -- existing callers still use getPremiumLabel.
  getPremiumLabel(content, user) {
    return Utils.getSubscriptionLabel(content, user);
  },

  getPreviewLabel(content_type, previewMode = 'teacher') {
    const isStudentPreview = previewMode === 'student';
    return (
      <div
        className="p-2 text-bold text-center"
        style={{
          backgroundColor: '#D2C0DC',
          color: '#682D8A',
          lineHeight: '1em',
        }}
      >
        <p className="mb-0">
          {`${isStudentPreview ? 'Student' : 'Teacher'} Preview`}
        </p>
      </div>
    );
  },
  getTotalPoints(qa, questionAssignmentPoints) {
    let points = 1;
    const stepPoints =
      questionAssignmentPoints && questionAssignmentPoints[qa.step_id];
    if (stepPoints && stepPoints[qa.questionId] != null) {
      // Use teacher-updated point from assignment
      points = stepPoints[qa.questionId];
    } else if (qa.points != null) {
      // Use default point from content
      points = qa.points;
    }
    return points;
  },
  slugify(text, index) {
    return (
      text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') +
      '-attrib' +
      index
    ); // Trim - from end of text
  },

  getPlotInfoForInsertDataInstance(dataWithPlotState) {
    let columns = ['Case'];
    let column_ids = ['id'];
    let rows = [];
    let metadata = {
      fields: [
        {
          sort: 'ascending',
          name: 'Case',
          long_name: '',
          subtype: '',
          type: '',
          id: 'id',
          categories: [],
        },
      ],
    };
    let plotState = null;

    if (dataWithPlotState) {
      // For colum names and column ids
      if (
        dataWithPlotState.rawData[0] &&
        dataWithPlotState.rawData[0].length >= 1
      ) {
        for (
          let index = 0;
          index < dataWithPlotState.rawData[0].length;
          index++
        ) {
          const text = dataWithPlotState.rawData[0][index];
          column_ids.push(this.slugify(text, index + 1));
          columns.push(text, index + 1);
        }
      }
      // Populate rows with case number
      for (let index = 1; index < dataWithPlotState.rawData.length; index++) {
        const values = dataWithPlotState.rawData[index];
        if (values && values.length >= 1) {
          values.unshift(index);
          rows.push(values);
        }
      }
      // Set column_ids from saved state
      if (dataWithPlotState.columnIds?.length > 0) {
        column_ids = dataWithPlotState.columnIds;
      }
      // Metadata
      metadata = dataWithPlotState.metaData;
      // Plotstate
      plotState = dataWithPlotState.plotState;
    }

    return {
      columns,
      column_ids,
      rows,
      metadata,
      plotState,
    };
  },

  getToolsLanguage(datasetLanguage, languagePreference) {
    if (!datasetLanguage || datasetLanguage === 'en-US') {
      return (
        LANGUAGE_OPTIONS.find(lang => lang.key === languagePreference)
          ?.toolsLang || 'en-US'
      );
    }
    return datasetLanguage;
  },
};

export default Utils;
